// Permisos en el frontend. Espeja la lógica del backend (middleware/permisos.js).
// El objeto `user` (de login/me) trae user.permisos = { modulo: {ver, editar} }.

export function puede(user, modulo, nivel = 'ver') {
  if (!user) return false;
  if (user.es_super_admin) return true;
  if (!user.perfil_id && user.rol === 'administrador') return true; // compat
  const p = user.permisos && user.permisos[modulo];
  if (!p) return false;
  return nivel === 'editar' ? p.editar === true : (p.ver === true || p.editar === true);
}

// Catálogo de módulos (espejo de backend/src/config/modulos.js) para la matriz de perfiles.
export const MODULOS = [
  { key: 'dashboard',     label: 'Dashboard' },
  { key: 'clientes',      label: 'Clientes' },
  { key: 'productos',     label: 'Productos' },
  { key: 'cotizaciones',  label: 'Cotizaciones' },
  { key: 'proyectos',     label: 'Proyectos y OT' },
  { key: 'taller',        label: 'Taller' },
  { key: 'compras',       label: 'Compras' },
  { key: 'facturacion',   label: 'Facturación' },
  { key: 'pos',           label: 'Punto de Venta (POS)' },
  { key: 'recepcion',     label: 'Facturas recibidas' },
  { key: 'nomina',        label: 'Nómina' },
  { key: 'rh',            label: 'Recursos Humanos' },
  { key: 'sgsst',         label: 'SG-SST' },
  { key: 'contabilidad',  label: 'Contabilidad' },
  { key: 'reportes',      label: 'Reportes' },
  { key: 'configuracion', label: 'Configuración' },
  { key: 'usuarios',      label: 'Usuarios y perfiles' },
  { key: 'cms_web',       label: 'Gestor Web (CMS)' },
];
